<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
            <el-form-item label="分销状态："> 
                <el-select v-model="searchForm.isSold" clearable>
                    <el-option label="未分销" value="0"></el-option>
                    <el-option label="已分销" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡状态："> 
                <el-select v-model="searchForm.cardState" clearable>
                    <el-option v-for="item in cardStateOption" :value="item.code" :key="item.id + item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商名称："> 
                <el-select v-model="searchForm.supplierCode" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name + '(' + item.alias + ')'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐组名称："> 
                <el-select v-model="searchForm.basePkgGroup" clearable filterable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分销商：">
                <el-input v-model.trim="searchForm.agentName" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
              <el-form-item label="虚拟号：">
                <el-input v-model.trim="searchForm.virtualNo" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
              <el-form-item label="专属靓号：">
                <el-input v-model.trim="searchForm.phoneNo" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号段：" class="ICCIDRange">
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidStart" clearable></el-input>
                </el-col>
                <el-col :span="2" class="separate">-</el-col>
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidEnd" clearable></el-input>
                </el-col>                
            </el-form-item>
            <br/>
            <el-form-item label="已使用流量(G)：" class="iccid_number_input">
                <el-row style="display:flex;width:400px;">
                    <el-col style="flex:3">
                        <el-select  clearable v-model="searchForm.op" placeholder="请选择">
                            <el-option
                            v-for="item in ops"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="1" class="separate"></el-col>
                    <el-col style="flex:7">
                        <el-input-number :min="0" v-model="searchForm.usedFlowRate" clearable></el-input-number>
                    </el-col>
                </el-row>                
                
            </el-form-item>

            <el-form-item label="剩于流量(G)：" class="iccid_number_input">
                <el-row style="display:flex;width:400px;">
                    <el-col style="flex:3">
                        <el-select  clearable v-model="searchForm.op2" placeholder="请选择">
                            <el-option
                            v-for="item in ops"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="1" class="separate"></el-col>
                    <el-col style="flex:7">
                        <el-input-number :min="0" v-model="searchForm.plusFlowRate" clearable></el-input-number>
                    </el-col>
                </el-row>                
                
            </el-form-item>
            <br/>
            <el-form-item label="ICCID列表：" class="iccid_textarea_range">
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入1个或多个ICCID号,多个请用逗号、空格、或者换行分隔"
                    v-model="searchForm.iccidStrs">
                    </el-input>
            </el-form-item>

            <!-- <el-form-item label="排序规则："> 
                <el-select v-model="searchForm.orderBy" clearable>
                    <el-option label="过期时间" value="expire_time"></el-option>
                    <el-option label="使用流量" value="use_flow"></el-option>
                </el-select>
            </el-form-item> -->

            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getAdminCardListHandler">搜索查询</el-button>
                <el-button type="success"  @click="exportSimInfoHandle">导出Excel</el-button>
                <el-button type="primary"  @click="showSimHandle">SIM卡分销</el-button>
                <el-button type="warning" @click="simRecycleHandle">SIM卡回收</el-button>
                <el-button type="warning" @click="showBatchChgStateHandler1">卡板删除</el-button>
                <el-button type="warning" @click="showBatchChgStateHandler2">卡板迁移</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >
            <el-table-column label="ICCID号" width="180px">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
             <el-table-column prop="virtualNo" label="虚拟号"></el-table-column>
             <el-table-column prop="phoneNo" label="专属靓号"></el-table-column>
            <el-table-column prop="intoNo" label="接入号" width="130px"></el-table-column>
            <el-table-column prop="supplierName" label="供应商名称"></el-table-column>
            <el-table-column prop="alias" label="通道" width="80px"></el-table-column>
            <el-table-column prop="createTime" label="导入时间"  width="140px"></el-table-column>
            <el-table-column prop="batchNo" label="导入批次" width="80px"></el-table-column>
            <el-table-column prop="basePkgGroupName" label="套餐组"></el-table-column>
            <el-table-column label="总流量(G)" width="80px">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.flowRate) }}
                </template>
            </el-table-column>
            <el-table-column label="已使用流量(G)" width="110px">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.usedFlowRate) }}
                </template>
            </el-table-column>
            <el-table-column label="剩余流量(G)" width="100px">
                <template slot-scope="scope">
                    {{ decrease(fluxMtoG(scope.row.flowRate), fluxMtoG(scope.row.usedFlowRate)) }}
                </template>
            </el-table-column>
            <el-table-column prop="flowRatePercent" label="可用流量比" width="90px">
                <template v-slot="scope">
                    <span v-if="scope.row.flowRatePercent!=null && scope.row.flowRatePercent!=undefined && scope.row.flowRatePercent!=''">{{scope.row.flowRatePercent}} %</span>
                </template>
            </el-table-column>
            <el-table-column  label="分销商" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="color: #f54848;">{{ formatAgentNamePrefix(scope.row.agentPathNames)}}</span>{{ scope.row.agentPathNames}}
                </template>
            </el-table-column>

            <el-table-column prop="cardStateName" label="卡状态"  width="100px"></el-table-column>

            <el-table-column prop="isSoldName" label="分销状态" width="100"></el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  title="卡片分销" :visible.sync="simHandleVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="simHandleForm" :model="simHandleForm" :rules="simHandleRules" label-width="120px">
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="simHandleForm.agentId" filterable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>  
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="simDistributHandler">确 定</el-button>
            </div>
        </el-dialog>      
        
        


        
        <el-dialog :append-to-body="true"  title="批量删除" :visible.sync="batchOptVisible1" width="600px" @close="cancel" :close-on-click-modal="false">
             <p style="color:red">批量删除后 数据无法进行恢复！请谨慎操作</p>
            <el-form ref="batchOptForm1" :model="batchOptForm1" :rules="changeStateRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('batch/change/delete/sim')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler1">确 定</el-button>
            </div> 
        </el-dialog>    



        <el-dialog :append-to-body="true"  title="批量变更通道" :visible.sync="batchOptVisible2" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm" :rules="changeStateRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('import/sim/state/update/supplier')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                
                <el-form-item label="新通道：" prop="supplierCode">
                    <el-select v-model="batchOptForm.supplierCode" clearable>
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="'转'+item.name"></el-option>
                    </el-select>
                </el-form-item>
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler2">确 定</el-button>
            </div> 
        </el-dialog>      


    </div>
</template>

<script>
import {getAdminCardList, simDistribut, simRecovery, getCardStateDict,exportSimInfo} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm: {
                phoneNo:'',
                isSold: '',
                cardState: '',
                supplierCode: '',
                basePkgGroup: '',
                agentName: '',
                iccid: '',
                intoNo: '',
                iccidStart: '',
                iccidEnd: '',
                orderBy:'',
                usedFlowRate:null,
                plusFlowRate:null,
                op:'',
                op2:'',
                virtualNo:null
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },            
            simHandleVisibale: false,
            simHandleForm: {
                agentId: ''
            },
            pkgGroup: [],
            branchSupplierOption: [],
            agentListOption: [],
            cardStateOption: [],

            virtualStateArray:[],
            simHandleRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'change'}]
            },
            ops:[
                {label:'等于',value:"="},
                {label:'大于',value:">"}
            ],
            batchOptVisible1:false,
            batchOptVisible2:false,
            batchOptForm1: {
                state: '',
                remark:'',
            },
            batchOptForm:{
                supplierCode:'',
            }


        }
    },
    methods: {
        sureBatchChgStateHandler2(){ 
            this.$refs.batchOptForm.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
            });
        },
        showBatchChgStateHandler2(){
            this.batchOptVisible2=true;
        },

        showBatchChgStateHandler1(){
            this.batchOptVisible1 = true;
        },
        sureBatchChgStateHandler1(){ 
            this.$refs.batchOptForm1.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
            });
        },
        handleSuccess(res){
            if(res.code == 200){
                this.$message.success(res.message);
                this.getAdminCardListHandler();
            }else{
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.upload.clearFiles();
        },
        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if(fileList.length > 1){
                fileList.splice(0,1);
            }
            
        },



        cancel(){
            this.batchOptVisible2=false;
            this.batchOptVisible1 = false;
            this.simHandleVisibale = false;    
            this.$refs.simHandleForm.resetFields();  
        },

        getAdminCardListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            if(data.usedFlowRate){
                data.usedFlowRate = data.usedFlowRate * 1024;
            }

            if(data.plusFlowRate){
                data.plusFlowRate = data.plusFlowRate * 1024; 
            }
            getAdminCardList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        showSimHandle(){            
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            if(iccidStart == "" || iccidEnd == ""){
                this.$message.error('请输入要分销的ICCID号段');
                return false;
            }else{
                this.simHandleVisibale = true;
                common.getAgentListOptionCom(this, 'agentListOption');
            }
        },
        simRecycleHandle(){
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            if(iccidStart == "" || iccidEnd == ""){
                this.$message.error('请输入要回收的ICCID号段');
                return false;
            }
            this.$confirm('确定回收这批卡片吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var data = {
                    iccidStart,
                    iccidEnd
                }
                simRecovery(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAdminCardListHandler();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(()=>{})
        },
        simDistributHandler(){
            this.$refs.simHandleForm.validate(valid => {
                if(valid){
                    var data = {
                        iccidStart: this.searchForm.iccidStart,
                        iccidEnd: this.searchForm.iccidEnd,
                        agentId: this.simHandleForm.agentId
                    }
                    simDistribut(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success('分销完成');
                            this.simHandleVisibale = false;
                            this.getAdminCardListHandler();
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAdminCardListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAdminCardListHandler();
        },        
        exportSimInfoHandle(){//导出excel文件
            this.$confirm("您确定要导出SIM卡列表吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {

                let data = this.searchForm;
                if(data.usedFlowRate){
                    data.usedFlowRate = data.usedFlowRate * 1024;
                }
                if(data.plusFlowRate){
                    data.plusFlowRate = data.plusFlowRate * 1024; 
                }

                exportSimInfo(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去下载专区下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err)); 
            })          
        },

        //检查是不是自收款代理商
        formatAgentNamePrefix(name){

            let names = ['盛世蓝泰科技','云游互动云游卡','蔡伟成','野马通信','魅友通','四海龙腾'];
            let pre = '';
            if(name){
                names.forEach(function(currentValue){
                    if(name.indexOf(currentValue) == 0){
                        pre = '【自收款】'
                    }
                });
                return pre;
            }
            return '';
        }
        
    },
    created () {
        
        common.getPkgGroupListCom(this, 'pkgGroup');
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
        getCardStateDict({}).then(res => {
            if(res.data.code == 200){
                this.cardStateOption = res.data.data;
                let virtualCardStateOption = [];
                for(let i=0; i<res.data.data.length; i++){
                    if(res.data.data[i].code<5 || res.data.data[i].code==11){
                        virtualCardStateOption.push(res.data.data[i]);
                    }                    
                }
                for (let i=0; i<virtualCardStateOption.length; i++) {
                    this.virtualStateArray.push(virtualCardStateOption[i].code);
                }
            }else{
                this.$message.error(res.data.message);
            }    
        })

        this.getAdminCardListHandler();
    }
}
</script>

<style lang="less" scoped>

</style>

